import * as React from 'react';
import { fetchApi, makeResetCache, notifyError, notifyResponse, RecordPicker } from 'gossamer-front-end';
import { AdminOrgUnitEventAddRequest, Event, OrgUnitEvent, OrgUnitEventView } from 'cb-model';
import { InputGroup } from 'react-bootstrap';
import { FieldType, getFilter } from 'gossamer-unified';
import { useDispatch } from 'react-redux';

export interface AddEventToOrgUnitButtonProps {
  orgUnitId: number;
}

export const AddEventToOrgUnitButton: React.FC<AddEventToOrgUnitButtonProps> = (props): React.JSX.Element => {
  const dispatch = useDispatch();
  const resetCache = makeResetCache(dispatch);
  const isProcessing = React.useRef(false);

  const handleAdd = async (eventId: string) => {
    if (isProcessing.current) {
      return;
    }
    try {
      isProcessing.current = true;
      const resp = await fetchApi('POST', `/main/org-unit-event-add`, {
        eventId: parseInt(eventId),
        orgUnitId: props.orgUnitId,
      } as AdminOrgUnitEventAddRequest);
      resetCache(OrgUnitEvent.id);
      resetCache(OrgUnitEventView.id);
      notifyResponse(resp);
    } catch (e) {
      notifyError(e, 'An error occurred while adding the event to the org unit');
    }
    isProcessing.current = false;
  };
  return (
    <InputGroup>
      <InputGroup.Text>Add an existing Event to this Org Unit</InputGroup.Text>
      <RecordPicker
        editable={true}
        onItemSelected={handleAdd}
        value={null}
        field={{
          seq: 0,
          type: FieldType.Reference,
          label: 'Event',
          refEntity: Event,
        }}
        queryOptions={{
          where: {
            and: [getFilter('title', 'ct', '')],
          },
          order: [['title', 'ASC']],
        }}
      />
    </InputGroup>
  );
};
